<template>
    <div>
        <br>
        <div class="row">
            <div class="col-sm-2">
                <span>Provinsi</span>
            </div>
            <div class="col-sm-1">
                <input type="text" class="form-control" value="74" disabled>
            </div>
            <div class="col-sm-3">
                <input type="text" class="form-control" value="SULAWESI TENGGARA" disabled>
            </div>
            <div class="col-sm-6"></div>
        </div>
        <br>
        <div class="row">
            <div class="col-sm-2">
                <span>Kota/Kab</span>
            </div>
            <div class="col-sm-1">
                <input type="text" class="form-control" value="05" disabled>
            </div>
            <div class="col-sm-3">
                <input type="text" class="form-control" value="KONAWE SELATAN" disabled>
            </div>
            <div class="col-sm-6"></div>
        </div>
        <br>
        <div class="row">
            <div class="col-sm-2">
                <span>Kecamatan</span>
            </div>
            <div class="col-sm-1">
                <input type="text" class="form-control">
            </div>
            <div class="col-sm-3">
                <input type="text" class="form-control" disabled>
            </div>
            <div class="col-sm-6"></div>
        </div>
        <br>
        <div class="row">
            <div class="col-sm-2">
                <span>Kelurahan</span>
            </div>
            <div class="col-sm-1">
                <input type="text" class="form-control">
            </div>
            <div class="col-sm-3">
                <input type="text" class="form-control" disabled>
            </div>
            <div class="col-sm-6"></div>
        </div>
        <br>
        <div class="row">
            <div class="col-sm-2">
                <span>Tahun</span>
            </div>
            <div class="col-sm-1">
                <input type="text" class="form-control">
            </div>
            <div class="col-sm-1">
                <span>s/d</span>
            </div>
            <div class="col-sm-1">
                <input type="text" class="form-control">
            </div>
            <div class="col-sm-9"></div>
        </div>
        <br>
        <div class="row">
            <div class="col-sm-2">
                <span>Ketetapan</span>
            </div>
            <div class="col-sm-1">
                <input type="text" class="form-control">
            </div>
            <div class="col-sm-1">
                <span>s/d</span>
            </div>
            <div class="col-sm-1">
                <input type="text" class="form-control">
            </div>
            <div class="col-sm-9"></div>
        </div>
        <br>
        <div class="row">
            <div class="col-sm-2">
                <span>No Surat</span>
            </div>
            <div class="col-sm-3">
                <input type="text" class="form-control">
            </div>
            <div class="col-sm-7"></div>
        </div>
        <br>
        <div class="row">
            <div class="col-sm-2">
                <span>Tanggal Terbit</span>
            </div>
            <div class="col-sm-3">
                <input type="text" class="form-control">
            </div>
            <div class="col-sm-7"></div>
        </div>
        <br> <hr>
        <div class="row">
            <div class="text-center">
                <button type="button" class="btn bg-light-blue btn-sm waves-effect"><i class="material-icons">check</i>Cetak</button>
                &nbsp;
                <button type="button" class="btn bg-light-blue btn-sm waves-effect"><i class="material-icons">clear</i>Batal</button>
            </div>
        </div>
        <br>
    </div>
</template>

<script>
export default {

}
</script>

<style>

</style>
